import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { MailingId } from '../../types/mailing-interface';
export const useUserData = t0 => {
  const $ = _c(6);
  const {
    mailingId,
    isFetchAllowed
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== mailingId || $[2] !== user) {
    t2 = () => user && `/api/dashboard/manager/mailing/${mailingId}/user`;
    $[1] = mailingId;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data
  } = useControlledSwr(t2, fetcher, undefined, isFetchAllowed);
  let t3;
  if ($[4] !== data) {
    t3 = {
      userData: data
    };
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};